import React from "react";
import { RoleProps } from "../index";
import { Form } from "../../../../components";
import {
  InstructionWrapper,
  TextField,
  ToggleSwitch,
} from "../../../../components/fields";
import Heading from "../../../../_global/components/heading/Heading";
import "./_styles.scss";
import { Card } from "@mui/material";
import { UserPermissions } from "../../../../definitions";

export default function ViewItem({
  data: { rolename, permissions, is_active },
}: RoleProps) {
  const displayName = `
    ${rolename ?? ""} ${ " | "} ${is_active? "Active": "Inactive" }`.trim();

  return (
    <div id="role-view-item" className="read-only">
      <Heading name={displayName} />
      <Form title="Role Details">
        <InstructionWrapper
          text="Role details"
          row
        >
          <TextField label="Name" value={rolename} readOnly />
         <ToggleSwitch
            label="Is active"
            name="is_active"
            value={is_active}
            readOnly
            className="half-width"
          />
        </InstructionWrapper>        
      </Form>

      <Form title={"Permissions"}>         
        <InstructionWrapper text="Permissions">
        <div className="flex-row">
        <div className="label-col">
        <TextField           
            value={" "}
            readOnly
          />  
          </div>
           <div className="switch-col">            
           <TextField           
            value={"View"}
            readOnly
          />  
          </div>
          <div className="switch-col">
           <TextField           
            value={"Edit"}
            readOnly
          />  
          </div>
          </div>
        </InstructionWrapper>

      {     
                
      UserPermissions.userPermissions.map((userPermission, i) => {
        return (         
          <div key={"permissions_card_"+i}>
             <InstructionWrapper row text={userPermission.label +" Permissions"}>
              <Card             
                className="program-card-edit page-padding"
              >
                {                  
               ([userPermission, ...(userPermission.nested_permissions? userPermission.nested_permissions:[])]).map((permission, index) => {
              return (           
              <div key={userPermission.label+index} className="flex-row">
                  <div  className="label-col">
                    <TextField
                    className={index > 0 ? "nested-label":""}
                      value={permission.label}                 
                      readOnly
                    ></TextField>
                  </div>
                  
                  <div className="switch-col">                    
                    { permission.view ? (
                        <ToggleSwitch
                          label=""
                          name={permission.view}
                          value={(permissions?.includes(permission.view)) }                                     
                          readOnly = {true}
                        /> 
                        ):<ToggleSwitch
                          label=""
                          className="switch-hide"
                          name={permission.view}
                          value={false}  
                          readOnly = {true}                   
                        /> 
                    }
                    </div>
                  <div className="switch-col">  
                    { permission.edit ? (
                        <ToggleSwitch
                          label=""
                          name={permission.edit}
                          value={(permissions?.includes(permission.edit))}  
                          readOnly = {true}                                          
                        /> 
                        ): <ToggleSwitch
                          label=""
                          className="switch-hide"
                          name={permission.edit}
                          value={false}  
                          readOnly = {true}                   
                        /> 
                    }
                  </div> 
                </div>               
            )
          })    
        } 
    </Card>
    </InstructionWrapper>            
  </div>       
  );
})}
      </Form>   
    </div>
  );
}
